// @flow

import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getPackages } from '../../store/configuration/actives';
import { getSoldOutLabel } from '../../store/configuratorSettings/selectors';
import {
  getButtonText,
  getPriceLabel,
  getUniqueFeaturesLabel,
} from '../../store/componentSettings/selectors';
import Price from '../price';
import {
  SoldOutOverlay,
  Capsule,
  Highlights,
} from './atoms';
import {
  getPrice,
  getConfigLink,
} from '../../store/pdb';
import Button from '../button';
import {
  ImageContainer,
  Title,
  StyledPrice,
  Wrapper,
  StyledCard,
  PriceText,
  CompareWrapper,
} from './packages.styled';
import type { Package } from '../../types/pdb';
import type { Theme } from '../../types';
import ImageComponent from './atoms/image';
import PackageCompareComponent from '../packageCompare';

type StateProps = {|
  packages: Array<Package>,
  soldOutLabel: string,
  basePrice: string,
  configLink: string,
  buttonText: string,
  priceLabel: string,
  uniqueFeaturesLabel: string,
|};

type Props = StateProps;

const PackageCompare = styled<typeof PackageCompareComponent, Theme>(PackageCompareComponent)`
  table {
    width: 100%;
  }
  width: 100%;
`;

// @TODO: When we need a single package component we should extract it from below
const Packages = ({
  packages,
  soldOutLabel,
  basePrice,
  configLink,
  buttonText,
  priceLabel,
  uniqueFeaturesLabel,
}: Props) => (
  <Wrapper>
    {packages.map(({
      id,
      name,
      price,
      mapped: {
        soldOut,
      },
      contains = [],
      default_image,
    }) => (
      <StyledCard
        key={id}
        variant="shadow"
        backgroundColor="default"
      >
        {soldOut && (
          <SoldOutOverlay>
            <Capsule>{soldOutLabel}</Capsule>
          </SoldOutOverlay>
        )}
        {default_image && default_image.url && (
          <ImageContainer>
            <ImageComponent
              src={default_image.url}
              alt={default_image.alt}
              className=""
            />
          </ImageContainer>
        )}
        <Title>{name}</Title>
        <StyledPrice>
          <Price
            amount={parseFloat(basePrice) + parseFloat(price)}
            displayCurrencyText
            decimalDash={false}
          />
          <PriceText>{priceLabel}</PriceText>
        </StyledPrice>
        <Highlights
          title={uniqueFeaturesLabel}
          items={contains.filter(item => item.highlight) || []}
        />
        <Button
          caret
          fullWidth
          href={`${configLink}?pkg=${id || ''}`}
          colors="secondary"
        >
          {buttonText}
        </Button>
      </StyledCard>
    ))}
    <CompareWrapper>
      <PackageCompare />
    </CompareWrapper>
  </Wrapper>
);

const mapStateToProps = (state, { pdbId }): StateProps => ({
  packages: getPackages(state, pdbId),
  soldOutLabel: getSoldOutLabel(state),
  basePrice: getPrice(state),
  configLink: getConfigLink(state, pdbId),
  buttonText: getButtonText(state),
  priceLabel: getPriceLabel(state),
  uniqueFeaturesLabel: getUniqueFeaturesLabel(state),
});

export default connect<any, any, StateProps, any, any, any>(mapStateToProps)(Packages);
